module.exports = __webpack_public_path__ + "img/4.2679b632.png";